import { useState } from "react";
import { Box, Chip, FormControl, Grid, IconButton, TextField, Typography } from "@mui/material";
import { formatPhoneNumber } from "../../common/util";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import EmailInput from "../../common/component/EmailInput";
import CustomerLookup from "../../common/search/CustomerLookup";
import LoyaltyStatus from "../../common/component/LoyaltyStatus";

export default function CustomerDetailEntry(props) {
  const { customer } = props;

  const [mode, setMode] = useState(props.mode);

  if (customer && mode === "view") {
    return (
      <Box sx={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
        <Box>
          <Typography variant="h6">
            {customer.firstName} {customer.lastName}
            {customer.type ? (
              <Chip size="small" label={customer.type} />
            ) : customer.loyaltyLevel ? (
              <LoyaltyStatus status={customer.loyaltyLevel} />
            ) : (
              ""
            )}
          </Typography>
          <Typography variant="body2" display="block">
            {formatPhoneNumber(customer.phone)}
          </Typography>
          <Typography variant="overline" display="block">
            {customer.email || ""}
          </Typography>
          {customer.email_cc && (
            <Typography variant="overline" display="block">
              cc: {customer.email_cc || ""}
            </Typography>
          )}
        </Box>
        <Box>
          <IconButton
            size="small"
            onClick={() => {
              props.onChange("");
              setMode("edit");
            }}
          >
            <ModeEditIcon />
          </IconButton>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <FormControl variant="outlined" fullWidth>
              <CustomerLookup
                excludeTypes={["commercial"]}
                value={customer?.phone || ""}
                onChange={(o) => {
                  if (o.phone && o.firstName) {
                    props.onChange(o);
                    setMode("view");
                  } else {
                    props.onChange({ ...customer, ...o });
                  }
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                value={customer?.firstName || ""}
                variant="outlined"
                fullWidth
                id="firstName"
                label="First Name"
                name="firstName"
                onChange={(e) => props.onChange({ ...customer, firstName: e.target.value })}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                value={customer?.lastName || ""}
                variant="outlined"
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                onChange={(e) => props.onChange({ ...customer, lastName: e.target.value })}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormControl variant="outlined" fullWidth>
              <EmailInput
                value={customer?.email || ""}
                onChange={(val) => props.onChange({ ...customer, email: val })}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    );
  }
}
